import { render, staticRenderFns } from "./delete-tips.vue?vue&type=template&id=d0053668&"
import script from "./delete-tips.vue?vue&type=script&lang=js&"
export * from "./delete-tips.vue?vue&type=script&lang=js&"
import style0 from "./delete-tips.vue?vue&type=style&index=0&id=d0053668&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports